import { createFileRoute } from '@tanstack/react-router';

import { RoomOverviewPage } from '~features/room-overview';

export const Route = createFileRoute('/_auth/_layout/room-overview')({
  component: RoomOverviewPage,
});
